import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";
import { externalOtApi } from "./external-otApi";
import { ExternalOt, UpdateExternalOt } from "./external-ot.interface";

export const fetchExternalOt = createAsyncThunk<
  APIResponse<ExternalOt[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOt/fetchExternalOt", async (_, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtApi.endpoints.getExternalOt.initiate()).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al obtener OT externas",
      details: data.details,
    });
  }
});

export const searchExternalOt = createAsyncThunk<
  APIResponse<ExternalOt[]>,
  string,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOt/searchExternalOt", async (search, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtApi.endpoints.searchExternalOt.initiate(search)).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al buscar OT externas",
      details: data.details,
    });
  }
});

export const fetchExternalOtById = createAsyncThunk<
  APIResponse<ExternalOt>,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOt/fetchExternalOtById", async (id, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtApi.endpoints.getExternalOtById.initiate(id)).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al obtener OT externa",
      details: data.details,
    });
  }
});

export const updateExternalOt = createAsyncThunk<
  APIResponse<ExternalOt>,
  { id: number; changes: UpdateExternalOt },
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOt/updateExternalOt", async ({ id, changes }, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtApi.endpoints.updateExternalOt.initiate({ id, changes })).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al actualizar OT externa",
      details: data.details,
    });
  }
});
